import { dataVideoFilm } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoFilm = /*#__PURE__*/createIcon(dataVideoFilm)
export default IconVideoFilm
